import { StringMap } from 'aws-sdk/clients/ecs';

import { BoundCurrentUserSelectors } from 'reactApp/modules/CurrentUserModule';

const moveParamsToUrlWithSideEffect = ({
    url,
    params = {},
}: {
    url: string;
    params?: object;
}) => {
    const varInUrlRegex = /(^.*\/?):([\w\d]+)(.*)/;
    let restUrl = url;
    while (varInUrlRegex.test(restUrl)) {
        const name = url.replace(varInUrlRegex, '$2');
        restUrl = restUrl.replace(varInUrlRegex, '$1$3');
        if (params[name] != null) {
            url = url.replace(varInUrlRegex, `$1${params[name]}$3`);
            delete params[name];
        }
    }

    return url;
};

const getModelUrlPidInjector = () => {
    return function(name: string, params: StringMap = {}) {
        if (!params.hasOwnProperty('pid')) {
            params.pid = BoundCurrentUserSelectors.getPid();
        }

        let url = this.fn[name + 'Url'] || this.fn.url;

        if (typeof url === 'function') {
            url = url(params);
        }

        return moveParamsToUrlWithSideEffect({
            url,
            params,
        });
    };
};

export const UrlHelper = {
    moveParamsToUrlWithSideEffect,
    getModelUrlPidInjector,
};
